import { TraceGroupingQuery } from "../../../param/generalSearchQuery";
import { ListDefinition } from "../../../param/listDefinitionType";
import { MultipleResultUnit, Result, ResultUnit } from "../generalSearchResult";
import { processNestedFunctions } from "../patternFunctions";

type TraceGroupingProps = {
  query: TraceGroupingQuery;
  listDefinitionsTable: Record<string, ListDefinition>;
  result: Result;
  workerContext: any;
};
export const traceGrouping = async ({
  query,
  listDefinitionsTable,
  result,
  workerContext,
}: TraceGroupingProps) => {
  const table: Record<string, MultipleResultUnit> = {};
  for (const content of result) {
    const keys = processNestedFunctions(
      query.groupKey,
      listDefinitionsTable,
      content.trace
    );
    const values = processNestedFunctions(
      query.groupValue,
      listDefinitionsTable,
      content.trace
    );

    keys.forEach((key) => {
      table[key] = table[key] ?? {
        trace: [],
        currentWord: new Set(),
      };

      content.trace.forEach((e, i) => {
        const set = (table[key].trace[i] = table[key].trace[i] ?? new Set());
        set.add(e);
      });
      values.forEach((value) => {
        table[key].currentWord.add(value);
      });
    });
  }
  console.log(table);
  return Object.values(table).map((e) => {
    const currentWord = Array.from(e.currentWord).join("/");
    const newe: ResultUnit = {
      trace: Array.from(e.trace).map((e2, i2) =>
        query.enableTrace.includes(i2)
          ? Array.from(e2).join("/")
          : Array.from(e2)[0]
      ),
      currentWord,
    };
    newe.trace.push(currentWord);
    return newe;
  });
};
